<template>
<div class="add-member">
        <div class="add-member-top">
            <div class="add-confirm-top-title">{{$t("添加")}}{{currentTab === 0 ? $t("管理员") : $t("成员")}}            </div>
            <div class="add-confirm-top-back-btn">
                <img src="@/assets/img/share/icon_file_close.png" @click.stop="closeAddMemberView"/>
            </div>
        </div>

        <div class="add-member-center">
            <div class="member-list-item" v-for="(item, index) in shouldAddMemberList">
                <div class="worker-avatar">
                    <div v-if="
                            item.toType === 'PERSON' && fileAvatar(item) === ''
                        " class="user-avatar" :style="avatarColorStye(item.toName)">
                        <div class="user-name">{{ userName(item.toName) }}</div>
                    </div>
                    <img v-else :src="fileAvatar(item)"/>
                </div>
                <div class="worker-info">
                    <div class="worker-name">
                        {{ shouldAddMemberName(item) }}
                    </div>
                    <div v-if="spaceId !== item.toSpace" class="worker-space-name">
                        @{{ item.spaceName }}
                    </div>
                </div>

                <a-dropdown class="setting-auth-editable" trigger="click" position="br" @select="cmd => handlerChangeAuth(cmd, index)" @popup-visible-change="(v: boolean) => dropdownMenuVisibleChange(v, index)">
                    <div class="worker-auth-editable" @click="openAuthList(item, index)" @mouseover="mouseAction(index, true)" @mouseleave="mouseAction(index, false)">
                        {{ authName(item.auth) }}
                        <img :src="changeEditableIcon(index)"/>
                    </div>
                    <template #content>
                        <div class="auth-list" v-for="(auth, i) in memberAuthList" :key="i">
                            <a-doption :value="i" :divided="
                                    ['ALL', 'RECOVER', 'DELETE'].includes(
                                        auth.id
                                    )
                                " :disabled="item.edit === false">
                                <div class="auth-name" :style="
                                        auth.id === item.auth
                                            ? 'color: #5C70FF !important'
                                            : ['DELETE', 'RECOVER'].includes(
                                                  auth.id
                                              )
                                            ? 'color: #FF4747 !important; margin-left: 36px'
                                            : 'color: #222329 !important; margin-left: 36px'
                                    ">
                                    <img v-show="auth.id === item.auth" src="@/assets/img/share/icon_file_selected.png"/>{{ auth.name }}
                                </div>
                                <div class="auth-desc">{{ auth.desc }}</div>
                            </a-doption>
                        </div>
                    </template>
                </a-dropdown>
            </div>
        </div>

        <div class="add-member-bottom">
            <div class="push-message">
                <span>
                    <a-checkbox v-model="pushMessage">
                        <span class="text" :class="messageClass">{{$t("发送通知消息")}}</span>
                    </a-checkbox>
                </span>
            </div>
            <div class="add-confirm-bottom-cancel-btn" @click="closeAddMemberView">{{$t("取消")}}            </div>
            <div class="add-confirm-bottom-add-btn" @click="addMemebers">{{$t("添加")}}            </div>
        </div>

        <a-modal class="file-share-common-dialog" v-model:visible="showDialog" :simple="true" :footer="false" :render-to-body="true" :mask-closable="false">
            <div class="content">
                <div class="title">
                    <img src="@/assets/img/share/icon_file_tip.png"/>{{$t("提示")}}                </div>
                <div class="desc">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。")}}                </div>
                <div class="bottom">
                    <div class="cancel-btn" @click="showDialog = pushMessage = false">{{$t("取消")}}                    </div>
                    <div class="confirm-btn" @click="addConfirm">{{$t("确认发送")}}</div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { reactive } from 'vue';
import { MEMBER_AUTH_LIST } from '../../constants/SettingAuth';
import nameColor from '../../utils/nameColor';
import memberAvatar from '../../utils/avatar';
import EditableSelectedIcon from '@/assets/img/share/icon_file_auth_editable_selected.png';
import EditableHoverIcon from '@/assets/img/share/icon_file_auth_editable_hover.png';
import EditableIcon from '@/assets/img/share/icon_file_auth_editable.png';
import DepartmentAvatar from '@/assets/img/share/icon_file_file.png';
import GroupAvatar from '@/assets/img/share/fp_user_group.png';
import UnitedDepartmentAvatar from '@/assets/img/share/finder_dept_sub_united.png';

export default {
  name: 'AddMemberView',
  props: {
    addData: {
      type: Array<any> },

    currentTab: {
      type: Number },

    spaceId: {
      type: String } },


  data() {
    return {
      pushMessage: true,
      showDialog: false,
      shouldAddMemberList: this.addData,
      editableHover: reactive([]),
      editableFocus: reactive([]) };

  },
  computed: {
    messageClass() {
      return this.pushMessage ? '' : 'disable';
    },
    memberAuthList() {
      if (this.currentTab === 0) {
        let memberAuthList = MEMBER_AUTH_LIST;
        return reactive(
        memberAuthList.filter(
        (item: any) => item.id === 'DELETE' || item.id === 'ALL'));


      } else {
        return reactive(MEMBER_AUTH_LIST);
      }
    },
    shouldAddMemberName() {
      return (item) => {
        return item.toName;
      };
    } },

  methods: {
    closeAddMemberView() {
      this.$emit('closeAddMemberView');
    },
    addMemebers() {
      if (
      this.shouldAddMemberList.some(
      (item: any) => item.toType !== 'PERSON' && this.pushMessage))

      {
        this.showDialog = true;
      } else {
        this.addConfirm();
      }
    },
    addConfirm() {
      this.showDialog = false;
      this.$emit(
      'addConfirm',
      this.shouldAddMemberList,
      this.pushMessage);

    },
    authName(auth: string) {
      switch (auth) {
        case 'ALL':
          return intl.$t("所有权限");
        case 'READ':
          return intl.$t("仅查看");
        case 'READ_DOWNLOAD':
          return intl.$t("查看下载");
        case 'WRITE':
          return intl.$t("编辑");}

    },
    fileAvatar(item: any) {
      if (item.toType === 'PERSON' || item.toType === 'APP') {
        const userAvatar = memberAvatar.getMemberAvatar(
        item.toAvatar,
        '');

        return (
          userAvatar['100'] ??
          userAvatar['300'] ??
          userAvatar['original']);

      } else if (item.toType === 'GROUP') {
        if (item.toAvatar && item.toAvatar.length > 0) {
          return item.toAvatar;
        }
        return GroupAvatar;
      } else if (item.toType === 'USER_GROUP') {
        return GroupAvatar;
      } else if (
      item.toType === 'DEPARTMENT' &&
      item.toSpace !== this.spaceId)
      {
        return UnitedDepartmentAvatar;
      } else {
        return DepartmentAvatar;
      }
    },
    avatarColorStye(name: string) {
      let avatarColor = nameColor.getNameColor(name);
      return `background-color: ${avatarColor}`;
    },
    userName(name: string) {
      return nameColor.getLastName(name);
    },
    handlerChangeAuth(command: any, index: number) {
      if (this.memberAuthList[command].id === 'DELETE') {
        /// 删除协作者
        this.shouldAddMemberList.splice(index, 1);
        if (this.shouldAddMemberList.length === 0) {
          this.closeAddMemberView();
        } else {
          if (
          !this.shouldAddMemberList.some(
          (item: any) => item.toType !== 'PERSON'))

          {
            this.pushMessage = true;
          }
        }
      } else {
        this.shouldAddMemberList[index].auth =
        this.memberAuthList[command].id;
      }
    },
    openAuthList(item: any, index: number) {
      this.editableFocus[index] = !this.editableFocus[index];
      if (!this.editableFocus[index]) {
        return;
      }
      if (
      !this.memberAuthList.some((item: any) => item.id === 'DELETE'))
      {
        this.memberAuthList.push({
          id: 'DELETE',
          name: intl.$t("删除成员") });

      }
    },
    dropdownMenuVisibleChange(visible: boolean, index: number) {
      if (!visible) {
        this.editableFocus[index] = visible;
        this.editableHover[index] = visible;
      }
    },
    mouseAction(index: number, isHover: boolean) {
      if (this.editableFocus[index] === true && !isHover) {
        this.editableHover[index] = true;
        return;
      }
      this.editableHover[index] = isHover;
    },
    changeEditableIcon(index: number) {
      return this.editableFocus[index] ?
      EditableSelectedIcon :
      this.editableHover[index] ?
      EditableHoverIcon :
      EditableIcon;
    } },

  created() {
    this.shouldAddMemberList.map((item: any) => {
      if (item.toType !== 'PERSON') {
        this.pushMessage = false;
      }
    });
  },
  mounted() {} };
</script>

<style lang="scss" scoped>
.add-member {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    width: 100%;
    height: 100%;

    .add-member-top {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        line-height: 100%;
        margin-bottom: 24px;
        width: 100%;

        .add-confirm-top-back-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;
                object-fit: contain;
            }

            &:hover {
                background-color: #f4f6f9;
                border-radius: 4px;
            }
        }

        .add-confirm-top-title {
            display: flex;
            flex: 1;
            font-size: 16px;
            font-weight: 500;
            color: #121317;
            line-height: 100%;
        }
    }

    .add-member-center {
        width: 100%;
        height: 339px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        overflow-y: auto;
        overflow-x: hidden;

        .member-list-item {
            width: 100%;
            height: 52px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            flex-shrink: 0;
            cursor: pointer;

            &:hover {
                background-color: #f4f6f9;
                border-radius: 8px;
            }

            .worker-avatar {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 32px;
                border-radius: 8px;
                margin-right: 8px;
                margin-left: 16px;

                img {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                }

                .user-avatar {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .user-name {
                        font-weight: 600;
                        font-size: 12px;
                        color: #ffffff;
                        letter-spacing: 0;
                        line-height: 17px;
                    }
                }
            }

            .worker-info {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                flex: 1;
                height: 100%;
                margin-right: 4px;

                .worker-name {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222329;
                    letter-spacing: 0;
                    line-height: 20px;
                }

                .worker-space-name {
                    margin-left: 4px;
                    color: #fc7d29;
                    font-family: PingFangSC-Regular;
                    font-weight: 300;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    display: flex;
                    flex-shrink: 0;
                }
            }

            .worker-auth-editable {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-right: 16px;
                height: 32px;
                font-family: PingFangSC-Regular;
                font-weight: 300;
                font-size: 14px;
                color: #222329;
                letter-spacing: 0;
                text-align: center;
                line-height: 20px;
                border: none;
                background-color: transparent;
                cursor: pointer;

                &:hover {
                    color: #5c70ff;
                }

                img {
                    margin-left: 4px;
                    width: 10px;
                    height: 10px;
                    object-fit: contain;
                }
            }
        }
    }

    .add-member-bottom {
        width: 100%;
        margin-top: 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;

        .push-message {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: space-between;

            .text {
                color: #222329;
                line-height: 30px;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
            }

            .disable {
                color: #222329;
            }
        }

        .add-confirm-bottom-cancel-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            cursor: pointer;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #222329;
            text-align: center;
            line-height: 20px;
            background-color: #ffffff;
            width: 76px;
            height: 32px;
            border-radius: 8px;
            border: 1px solid #e6e8ec;

            &:hover {
                background-color: #f4f6f9;
            }
        }

        .add-confirm-bottom-add-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 20px;
            background-color: #5c70ff;
            width: 76px;
            height: 32px;
            border-radius: 8px;

            &:hover {
                background-color: #6d7dff;
            }
        }
    }
}
</style>

<style lang="scss">
@import '../share/theme/commonDialog.scss';
</style>
